module.exports = __webpack_public_path__ + "img/vip-head-icon.ec318962.png";